import React from 'react';
import { translate } from 'react-i18next';

import ProjectItem from './Item';

const defaultRenderItems = (projects) =>
  projects.map((project) => (
    <div
      key={project._id}
      className="o-layout__item u-1/1 u-1/2@maxi-stelyo u-margin-bottom"
    >
      <ProjectItem project={project} />
    </div>
  ));

const List = ({
  projects,
  titleColor,
  titlePrefixColor,
  titlePrefix,
  titleSuffix,
  title,
  renderItems,
  className = '',
  forceRendering,
  t,
}) => {
  if (!forceRendering) {
    if (!projects.length) {
      return null;
    }
  }

  return (
    <div className={className}>
      {(title || titlePrefix || titleSuffix) && (
        <h3 className={titleColor}>
          <span className={titlePrefixColor}>{projects.length} </span>
          <span className={titlePrefixColor}>{titlePrefix}</span>
          {title}
          <span className={titlePrefixColor}>{titleSuffix}</span>
        </h3>
      )}
      <div className="o-layout o-layout--stretch o-layout--large">
        {projects.length ? (
          renderItems(projects)
        ) : (
          <div className="o-layout__item u-1/1 u-margin-bottom">
            {t('user.noneProjectsAdded')}
          </div>
        )}
      </div>
    </div>
  );
};

List.defaultProps = {
  renderItems: defaultRenderItems,
};

export default translate()(List);



// WEBPACK FOOTER //
// ./src/projects/List.js